<template>
    <div class="layout-page">
        <div class="summary-container">
            <div class="summary-info">
                <div class="bills-generated">
                    <div class="title">
                        {{ $t('bills.bills_generated') }}
                    </div>
                    <div class="number">{{ kpis.total_bills }}</div>
                </div>
                <div class="bills-generated">
                    <div class="title">{{ $t('bills.clients') }}</div>
                    <div class="number">{{ kpis.total_customers }}</div>
                </div>
                <div class="bills-generated">
                    <div class="title">{{ $t('bills.import') }}</div>
                    <div class="number">{{ importMoney + '€' }}</div>
                </div>
            </div>
            <div class="summary-actions">
                <FilterBills v-on:applyFilters="resetSelectedItems()" v-on:resetFilters="resetSelectedItems()"></FilterBills>
                <div class="table-actions">
                    <!--
                    <div class="export">
                        <div class="export-button" @click="exportButton = !exportButton">{{ selected.length > 0 ? $t('bills.export') : $t('bills.export_all') }}</div>
                        <transition name="fade">
                            <div class="export-box" v-if="exportButton">
                                <div class="text" @click="downloadPDF()">{{ $t('bills.export_as_pdf') }}</div>
                                <div class="text" @click="downloadEXCEL()">{{ $t('bills.export_as_xlsx') }}</div>
                                <div class="text" @click="downloadXML()">{{ $t('bills.export_as_xml') }}</div>
                            </div>
                        </transition>
                    </div>
                    -->
                    <div class="search">
                        <input type="text" v-model="search" class="input-search" name="name" />
                    </div>
                </div>
            </div>
        </div>
        <div class="data-table">
            <v-data-table @toggle-select-all="allSelected = !allSelected" v-if="items" v-model="selected" :headers="headers" fixed-header :search="search" :items="Object.values(items)" sort-by="name" :single-select="singleSelect" :sort-asc="true" :items-per-page="20" hide-default-footer show-select>
                <template #item.ticket_number="item">
                    <div class="ticket">{{ '#' + item.item.ticket_number }}</div>
                </template>
                <template #item.corrective_number="item">
                    <div class="ticket">{{ '#' + item.item.corrective_number }}</div>
                </template>
                <template #item.date="item">
                    <div class="row">{{ moment(item.item.date * 1000).format('DD/MM/YYYY') }}</div>
                </template>
                <template #item.price="item">
                    <div class="row">{{ parseFloat(item.item.price).toFixed(2) + '€' }}</div>
                </template>
                <template #item.restaurant="item">
                    <div class="row">{{ restaurants(item.item.restaurant).code + ' - ' + restaurants(item.item.restaurant).name }}</div>
                </template>
                <template #item.customer_name="item">
                    <div class="row">{{ item.item.customer_name + ' - ' + item.item.customer_fiscal_id }}</div>
                </template>
                <template #item.file="item">
                    <div class="row-image" v-if="item.item.file">
                        <a target="_blank" :href="item.item.file"><img class="icon" src="../../public/img/pdf_icon.svg" /></a>
                    </div>
                </template>
                <template v-slot:no-data>
                    <div class="no-data">
                        {{ $t('bills.table_no_data') }}
                    </div>
                </template>
            </v-data-table>
            <div id="pagination">
                <div class="totalItems">
                    <span class="total">
                        <strong class="total-results">{{ paginationTotal }}</strong>
                        {{ $tc('bills.results', paginationTotal) }}
                    </span>
                </div>
                <v-pagination :value="currentPage" color="#C4C4C4" :length="pageCount" :total-visible="maxPageVisibles" @input="onPageChange"></v-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import FilterBills from '../components/layout/admin/bills/CorrectiveFilter.vue'
export default {
    components: { FilterBills },
    name: 'CorrectiveBills',
    data() {
        return {
            search: '',
            pagination: { page: 1, itemsPerPage: 20 },
            allSelected: false,
            exportButton: false,
            singleSelect: false,
            valueFilter: 1,
            selected: [],
            maxPageVisibles: 10
        }
    },
    computed: {
        items() {
            const bills = this.$store.getters['bills/getCorrectiveBills']
            const sortedBills = Object.values(bills).sort((elementA, elementB) => {
                let result = 0
                if (elementA.date > elementB.date) result = -1
                if (elementA.date < elementB.date) result = 1
                if (elementA.date === elementB.date) result = this.sortBillNumber(elementA.ticket_number, elementB.ticket_number)
                return result
            })
            return sortedBills
        },
        kpis() {
            return this.$store.getters['bills/getCorrectiveBillsKpis'] || { total_bills: 0, total_import: 0, total_customers: 0 }
        },
        paginationTotal() {
            return this.$store.getters['bills/getCorrectiveBillsPagination'].total || 0
        },
        currentPage() {
            return this.$store.getters['bills/getCorrectiveBillsPagination'].page || 1
        },
        pageCount() {
            const p = this.$store.getters['bills/getCorrectiveBillsPagination']
            const total = p.total || 0
            const limit = p.limit || 20
            return limit > 0 ? Math.ceil(total / limit) : 0
        },
        headers() {
            return [
                {
                    text: this.$t('bills.corrective_invoice_number'),
                    align: 'start',
                    sortable: true,
                    sort: this.sortBillNumber,
                    value: 'ticket_number',
                    width: 'auto',
                    class: 'header-table'
                },
                {
                    text: this.$t('bills.corrective_number'),
                    align: 'start',
                    sortable: true,
                    sort: this.sortCorrectiveNumber,
                    value: 'corrective_number',
                    width: 'auto',
                    class: 'header-table'
                },
                {
                    text: this.$t('bills.corrective_date'),
                    value: 'date',
                    width: 'auto',
                    sortable: true,
                    class: 'header-table'
                },
                {
                    text: this.$t('bills.import'),
                    value: 'price',
                    align: 'start',
                    width: 'auto',
                    sortable: true,
                    class: 'header-table'
                },
                {
                    text: this.$t('bills.restaurant'),
                    value: 'restaurant',
                    align: 'start',
                    width: 'auto',
                    class: 'header-table'
                },
                {
                    text: this.$t('bills.user'),
                    value: 'customer_name',
                    align: 'start',
                    width: 'auto',
                    sortable: true,
                    class: 'header-table'
                },
                {
                    text: '',
                    value: 'file',
                    align: 'start',
                    width: '6px',
                    sortable: false,
                    class: 'header-table'
                }
            ]
        },
        importMoney() {
            const k = this.$store.getters['bills/getCorrectiveBillsKpis']
            return (k && k.total_import != null) ? parseFloat(k.total_import).toFixed(2) : '0.00'
        }
    },
    methods: {
        resetSelectedItems() {
            this.selected = []
            this.exportButton = false
        },
        restaurants(id) {
            if (id) {
                const restaurant = this.$store.getters['restaurant/getRestaurants'](id)
                if (restaurant) return restaurant
            }
        },
        sortBillNumber(elementA, elementB) {
            const a = String(elementA).split('MCD').map((n, i) => (i === 0 ? parseInt(n, 10) : n))
            const b = String(elementB).split('MCD').map((n, i) => (i === 0 ? parseInt(n, 10) : n))
            if (a[0] > b[0]) return -1
            if (a[0] < b[0]) return 1
            return a[1] > b[1] ? -1 : a[1] < b[1] ? 1 : 0
        },
        sortCorrectiveNumber(elementA, elementB) {
            return this.sortBillNumber(elementA, elementB)
        },
        onPageChange(page) {
            this.fetchCorrectiveBillsPage(page)
        },
        fetchCorrectiveBillsPage(page) {
            const filtersActive = this.$store.getters['bills/getBillsFiltersActive']
            const params = { ...filtersActive, page: page || 1, per_page: 20 }
            if (params.restaurants === 'admin.filters.all_restaurants') params.restaurants = ''
            if (params.customers === 'admin.filters.all_customers') params.customers = ''
            this.$store.dispatch('bills/loadCorrectiveBills', params)
        },
        async load() {
            this.$store.dispatch('init')
            await this.$store.dispatch('bills/loadFiltersBills')
            this.fetchCorrectiveBillsPage(1)
        }
    },
    created() {
        this.load()
    }
}
</script>

<style lang="scss">
.search {
    .input-search {
        background-image: url('../../public/img/searcher.svg');
    }
}
.cancel-invoice {
    font-weight: bold;
    background-color: #ffbc0d;
    padding: 4px 8px;
    border-radius: 4px;
    height: 30px;
    text-align: center;
}

.canceled {
    color: #b3b3b3;
}
</style>
